import React from "react";
import ArrayEditor from "./ArrayEditor";
import ObjectSection from "./ObjectSection";
import { FieldLabel, MediaField, TextField } from "./Fields";
import {
  humanize,
  looksLikeDocKey,
  looksLikeImageKey,
  looksLikeImageUrl,
  looksLikeMapUrlKey,
  looksLikeMultiline,
  looksLikeVideoKey,
  looksLikeVideoUrl,
} from "./helpers";

const FieldRouter = ({ keyName, value, onChange, path }) => {
  const label = humanize(keyName);

  if (Array.isArray(value)) {
    return <ArrayEditor label={label} value={value} onChange={onChange} keyName={keyName} path={path} />;
  }
  if (value !== null && typeof value === "object") {
    return <ObjectSection label={label} value={value} onChange={onChange} path={path} />;
  }
  if (typeof value === "boolean") {
    return (
      <div>
        <FieldLabel>{label}</FieldLabel>
        <button
          type="button"
          onClick={() => onChange(!value)}
          className={`text-xs px-3 py-1.5 rounded border ${value ? "bg-emerald-50 border-emerald-300 text-emerald-700" : "bg-zinc-100 border-zinc-300 text-zinc-600"}`}
          data-testid={`field-${path}`}
        >
          {value ? "Enabled" : "Disabled"}
        </button>
      </div>
    );
  }
  if (looksLikeDocKey(keyName)) {
    return <MediaField label={label} value={value} onChange={onChange} kind="doc" testid={`field-${path}`} />;
  }
  if (looksLikeVideoKey(keyName) || looksLikeVideoUrl(value)) {
    return <MediaField label={label} value={value} onChange={onChange} kind="video" testid={`field-${path}`} />;
  }
  if (looksLikeMapUrlKey(keyName)) {
    return <TextField label={label} value={value} onChange={onChange} multiline testid={`field-${path}`} />;
  }
  if (looksLikeImageKey(keyName) || looksLikeImageUrl(value)) {
    return <MediaField label={label} value={value} onChange={onChange} kind="image" testid={`field-${path}`} />;
  }
  return <TextField label={label} value={value} onChange={onChange} multiline={looksLikeMultiline(value)} testid={`field-${path}`} />;
};

export default FieldRouter;
